<template>
    <OffCanvasMenu ref="menu" @overlay-clicked="close">
        <ErrorBoundary>
            <ActivityOverlay v-if="loading"/>
            <router-view></router-view>
        </ErrorBoundary>
    </OffCanvasMenu>
</template>

<script>
import OffCanvasMenu from "../includes/OffCanvasMenu.vue";
import ActivityOverlay from "../includes/ActivityOverlay.vue";
import {EVENTS} from "./utils/events";
import {MFE_BASE_PATH, navigate} from "./utils/navigation";
import ErrorBoundary from "../errors/ErrorBoundary.vue";

export default {
    name: "Profile",
    components: {
        ErrorBoundary,
        ActivityOverlay,
        OffCanvasMenu
    },
    data() {
        return {
            loading: true,
        }
    },
    methods: {
        async close() {
            await this.$refs.menu?.$emit('close');
            // Timeout to show slide out animation in off canvas menu
            setTimeout(() => {
                if (this.$route.path !== MFE_BASE_PATH.ROOT) {
                    navigate(MFE_BASE_PATH.ROOT);
                }
            }, 450);
        },
        ready() {
            this.loading = false;
        },
        processing() {
            this.loading = true;
        }
    },
    mounted() {
        this.$root.$on(EVENTS.CLOSE, this.close);
        this.$root.$on(EVENTS.READY, this.ready);
        this.$root.$on(EVENTS.PROCESSING, this.processing);
    },
    beforeDestroy() {
        this.$root.$off(EVENTS.CLOSE);
        this.$root.$off(EVENTS.READY);
        this.$root.$off(EVENTS.PROCESSING);
    }
}
</script>